export const EmailTemplateMapKeywords = [
  '{{requester_full_name}}',
  '{{requester_first_name}}',
  '{{requester_last_name}}',
  '{{requester_company_id}}',
  '{{requester_company_code}}',
  '{{requester_company_name}}',
  '{{requester_phone_number}}',
  '{{requester_email}}',

  '{{supervisor_full_name}}',
  '{{supervisor_first_name}}',
  '{{supervisor_last_name}}',
  '{{supervisor_department_name}}',
  '{{supervisor_phone_number}}',
  '{{supervisor_email}}',
  '{{person_list}}',

  '{{reason}}'
] as const;

export type EmailTemplateMapKeywordsType = typeof EmailTemplateMapKeywords[number];
export type EmailTemplateMap = Record<EmailTemplateMapKeywordsType, string>;

export const mapKeywordsMeaning: EmailTemplateMap = {
  '{{person_list}}': 'รายชื่อบุคคลในระบบ',

  '{{requester_full_name}}': 'ชื่อ-นามสกุลตัวแทนผู้รับเหมา',
  '{{requester_first_name}}': 'ชื่อตัวแทนผู้รับเหมา',
  '{{requester_last_name}}': 'นามสกุลตัวแทนผู้รับเหมา',
  '{{requester_company_id}}': 'เลขภาษีบริษัทตัวแทนผู้รับเหมา',
  '{{requester_company_name}}': 'บริษัทตัวแทนผู้รับเหมา',
  '{{requester_company_code}}': 'รหัสบริษัทตัวแทนผู้รับเหมา',
  '{{requester_email}}': 'อีเมลตัวแทนผู้รับเหมา',
  '{{requester_phone_number}}': 'เบอร์โทรศัพท์ตัวแทนผู้รับเหมา',

  '{{supervisor_full_name}}': 'ชื่อ-นามสกุลผู้ควบคุมงาน',
  '{{supervisor_first_name}}': 'ชื่อผู้ควบคุมงาน',
  '{{supervisor_last_name}}': 'นามสกุลผู้ควบคุมงาน',
  '{{supervisor_department_name}}': 'หน่วยงานผู้ควบคุมงาน',
  '{{supervisor_phone_number}}': 'เบอร์โทรศัพท์ผู้ควบคุมงาน',
  '{{supervisor_email}}': 'อีเมลผู้ควบคุมงาน',

  '{{reason}}': 'เหตุผล'
};

export const defaultMapKeywords: EmailTemplateMap = {
  '{{person_list}}': '<p>1. นายทดสอบ คนที่1</p><p>2. นายทดสอบ คนที่2</p>',
  '{{requester_full_name}}': 'นายตัวแทน ผู้รับเหมา',
  '{{requester_first_name}}': 'ตัวแทน',
  '{{requester_last_name}}': 'ผู้รับเหมา',
  '{{requester_company_id}}': '0123456789123',
  '{{requester_company_name}}': 'บริษัท ทดสอบ จำกัด',
  '{{requester_company_code}}': '600210',
  '{{requester_email}}': 'requester@mail.com',
  '{{requester_phone_number}}': '0912345678',

  '{{supervisor_full_name}}': 'นายทดสอบ ผู้ควบคุมงาน',
  '{{supervisor_first_name}}': 'ทดสอบ',
  '{{supervisor_last_name}}': 'ผู้ควบคุมงาน',
  '{{supervisor_department_name}}': 'ptt',
  '{{supervisor_phone_number}}': '0812345678',
  '{{supervisor_email}}': 'supervisor@mail.com',

  '{{reason}}': 'ให้มาเปิด Online Registerใหม่ในวันพรุ่งนี้'
};

export const templateToHtml = (template: string, mapKeywords: EmailTemplateMap) => {
  let html = template;
  for (const [key, value] of Object.entries(mapKeywords)) {
    html = html.replaceAll(key, value);
  }
  return html;
};
